<script>
    import Icon from "../components/icons/Icon.svelte";

    export let value = 0;
    export let min = null;
    export let max = null;

    const plus_one = () => {
        value++;
        if (max != null && value > max) {
            value = max;
        }
    }

    const minus_one = () => {
        value--;
        if (min != null && value < min) {
            value = min;
        }
    }
</script>

<div class="input-group">
    <button type="button" class="btn btn-default" on:click={minus_one}>
        <Icon name="minus" />
    </button>
    <input type="text" class="form-control text-center" bind:value readonly>
    <button type="button" class="btn btn-default" on:click={plus_one}>
        <Icon name="plus" />
    </button>
</div>

